import { Button } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { FormEvent } from "react";
import { usePaymentLinkPayment } from "../hooks/usePaymentLinkPayment";

export const PaymentLinkPaymentForm = ({
  code,
  amount,
}: {
  code: string;
  amount: number;
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const { pay, loading, error } = usePaymentLinkPayment({ code });

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    await pay(stripe, elements);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className="text-sm font-semibold text-zinc-800">Card details</div>
      <PaymentElement />
      <Button
        type="submit"
        disabled={!stripe || !elements || loading}
        className="w-full"
      >
        {loading ? "Processing..." : `Pay ${formatCurrency(amount)}`}
      </Button>
      {error && <div className="text-center text-sm text-red-500">{error}</div>}
    </form>
  );
};
